import React from 'react'
import Link from 'gatsby-link'
import './VizPage.scss'

const VizPage = () => {
  return (
    <div className="viz-list">
      <h2>Data Visualizations</h2>
      <Link to="/viz/avocado">The History of American Avocados</Link>
    </div>
  )
}

export default VizPage



// WEBPACK FOOTER //
// ./src/pages/viz/index.js